/**
 * Shared login-as-customer logic. Used by Customers list and DSOK customer detail top menu.
 * @param {Object} customer - Customer object with users[0] containing { username, password }
 * @param {Object} deps - { setAuthToken, navigate, enqueueSnackbar, t }
 * @returns {Promise<void>}
 */
import authServices from "./auth-services";
import { getCustomer } from "./api/management";
import { ACCESS_SYSTEM_TICKETS_PATH } from "../utils/constants/roleMenuConfig";

export async function loginAsCustomer(customer, { setAuthToken, navigate, enqueueSnackbar, t }) {
  const user = customer?.users?.[0];
  if (!user?.username || !user?.password) {
    enqueueSnackbar(
      t("buttons.loginAsCustomer", { defaultValue: "Login as customer" }) +
        " " +
        t("notifications.wasFailed", { defaultValue: "failed" }),
      { variant: "error" }
    );
    return;
  }
  const data = await authServices.signIn({
    username: user.username,
    password: user.password,
    type: "hash",
  });
  const messageSuccess =
    t("buttons.loginAsCustomer", { defaultValue: "Login as customer" }) +
    " " +
    t("notifications.wasSuccessful", { defaultValue: "was successful" });
  enqueueSnackbar(messageSuccess, { variant: "success" });
  setAuthToken(data, true);
  if (data?.data?.customer?.url) {
    await getCustomer(data.data.customer.url);
  }
  const authUser = data?.user ?? data?.data?.user;
  const userType = authUser?.type ?? authUser?.typ;
  const path = Number(userType) === 6 ? ACCESS_SYSTEM_TICKETS_PATH : "/";
  navigate(path);
}
